import { pickBy } from '@/utils'
import AttrGoods from './attr-goods'
import CompPickerLink from '../../comps/comp-pickerLink'

export default {
  name: 'WgtJnGroupBuying',
  setting: [
    { label: '标题', key: 'title', component: 'input', value: '今日团购' },
    { label: '副标题', key: 'subtitle', component: 'input', value: '热卖推荐' }
  ],
  transformIn: (v) => {
    const { name, base, data } = v

    return {
      name,
      ...base
    }
  },
  transformOut: (v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          title: 'title',
          subtitle: 'subtitle'
        })
      },
      data: []
    })
  }
}
